var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellTilted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.01a2.5 2.5 0 1 1-4.84 1.3M9.08 4.78a2.08 2.08 0 0 0-2.36-3.02 2.08 2.08 0 0 0-.54 3.8m7.35 2.31a4.06 4.06 0 0 0-2.2-2.58 5.42 5.42 0 0 0-3.75-.31 5.42 5.42 0 0 0-3.09 2.14 4.06 4.06 0 0 0-.62 3.34c.5 1.84.4 3.3.09 4.41a9.35 9.35 0 0 0-.49 2.04c.06.14.1.18.24.24.13.05.66-.1 1.73-.38l9.89-2.65a6.87 6.87 0 0 0 1.68-.54c.1-.12.11-.17.09-.32-.02-.14-.5-.6-1.44-1.52a8.26 8.26 0 0 1-2.13-3.87Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellTilted);
export default __webpack_public_path__ + "static/media/bell-tilted.a845969e21cc723b21492966ca8e4f9c.svg";
export { ForwardRef as ReactComponent };